import { BuyerCookieService } from '@diamond/shared/utils';
import { QueryKey, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from '../stores';

export function useInvalidateToken(queryKey: QueryKey) {
  const queryClient = useQueryClient();
  const resetSession = useAuthStore((s) => s.resetSession);
  return () => {
    queryClient.cancelQueries({ queryKey });
    resetSession();
    BuyerCookieService.clearAllAuthCookies();
    queryClient.invalidateQueries({ queryKey });
  };
}
